import React, { useContext, useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import { IconButton, Snackbar, SnackbarContent } from "@mui/material";
import { AiOutlineCheckCircle, AiOutlineSend } from "react-icons/ai";
import {
  FaFacebook,
  FaGithub,
  FaLinkedinIn,
  FaWhatsapp,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { FiAtSign, FiPhone } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoClose } from "react-icons/io5";

import { ThemeContext } from "../../../contexts/theme-context";
import { contactsData } from "../../../data/contactsData";
import { DayPicker } from "react-day-picker";
import Chip from "@mui/material/Chip";
import "react-day-picker/style.css";

import "./contacts.css";
import axios from "axios";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DoneOutlineIcon from "@mui/icons-material/VerifiedOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

const ContactUI = ({ success, classes, form }) => {
  const { theme, isDark } = useContext(ThemeContext);
  const currentDate = new Date();
  const tommorow = currentDate.setDate(currentDate.getDate() + 1);
  const initialData = {
    timeSlot: "9pm - 10pm",
    interviewType: "online",
  };
  const [selectedDate, setSelectedDate] = useState(tommorow);

  function convertDateToString(dateString) {
    const date = new Date(dateString);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month}, ${day} ${year}`;
  }
  const [contactInfo, setContactInfo] = useState(initialData);

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
  function validatePhoneNumber(phoneNumber) {
    const pakistanMobileRegex = /^03\d{9}$/; // Pakistani mobile number format (03XXXXXXXXX)
    const internationalRegex = /^\+?\d{10,15}$/; // International phone number format

    return (
      pakistanMobileRegex.test(phoneNumber) ||
      internationalRegex.test(phoneNumber)
    );
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // setContactInfo((prevData) => ({
    //   ...prevData,
    //   timeSlot: "9pm - 10pm",
    //   interviewType: "online",
    // }));
    // setSelectedDate(new Date())
  };
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [sumbitSuccess, setSumbitSuccess] = useState(true);
  const [submitClicked, setSubmitClicked] = useState(false);
  /* Existing code kept above */
  const handleSubmit = async () => {
    setSubmitClicked(true);
    if (!contactInfo.company) {
      return;
    }
    if (!contactInfo.YourName) {
      return;
    }
    if (!validateEmail(contactInfo.email)) {
      return;
    }
    if (!validatePhoneNumber(contactInfo.phone)) {
      return;
    }
    let formData = {
      ...contactInfo,
      Date: convertDateToString(selectedDate),
      createdDate: currentDate.toLocaleString(),
    };

    console.log("payload", formData);

    // Call Firebase
    try {
      const res = await axios.post(
        "https://interview-scheduler-80359-default-rtdb.firebaseio.com/.json",
        formData
      );
      console.log("response", res);

      // Call EmailJS
      const templateParams = {
        from_name: contactInfo.YourName,
        from_email: contactInfo.email,
        company: contactInfo.company,
        phone: contactInfo.phone,
        message: contactInfo.message,
        date: convertDateToString(selectedDate),
        time_slot: contactInfo.timeSlot,
        interview_type: contactInfo.interviewType,
        location_or_link:
          contactInfo.interviewType === "onsite"
            ? contactInfo.Location
            : contactInfo.meetingLink,
      };

      emailjs
        .send(
          "service_9yb1jo6",
          "template_yfnmw5e",
          templateParams,
          "mIDkNotSRjqCBZ0hu"
        )
        .then(
          (result) => {
            console.log("Email successfully sent!", result.text);
          },
          (error) => {
            console.log("Email failed to send:", error.text);
          }
        );

      setSumbitSuccess(true);
      setSubmitDisabled(true);
      setModalOpen(true);
    } catch (error) {
      setSumbitSuccess(false);
      setModalOpen(true);
      console.log("error", error);
    }

    console.log(formData);
  };

  useEffect(() => {
    setSubmitClicked(false);
  }, [contactInfo, selectedDate]);

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {sumbitSuccess ? (
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <DoneOutlineIcon color="success" />
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                color="#02B302"
                sx={{ ml: 1 }}
              >
                Interview scheduled successfully
              </Typography>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Interview has been scheduled successfully!
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 2,
              }}
            >
              <BusinessOutlinedIcon />
              <Typography id="modal-modal-description" sx={{ ml: 2 }}>
                {contactInfo.company}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 2,
              }}
            >
              <CalendarMonthOutlinedIcon />
              <Typography id="modal-modal-description" sx={{ ml: 2 }}>
                Date: {convertDateToString(selectedDate)} {contactInfo.timeSlot}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 2,
              }}
            >
              <PlaceOutlinedIcon />
              <Typography id="modal-modal-description" sx={{ ml: 2 }}>
                {contactInfo.interviewType}
              </Typography>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              I will ensure my availability for {contactInfo.company} at{" "}
              {convertDateToString(selectedDate)} {contactInfo.timeSlot}. You
              will receive a confirmation email from me shortly.
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Thank you {contactInfo.YourName} scheduling the interview! I'm
              looking forward to speaking with you soon!{" "}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Best reguards
            </Typography>
            <Typography>Hannan Shehzad</Typography>
          </Box>
        ) : (
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <ErrorOutlineIcon color={"error"} />
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                color="error"
                sx={{ ml: 1 }}
              >
                Error Scheduling Interview
              </Typography>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Sorry, I encountered an issue scheduling your interview. Please
              contact me directly to arrange a time:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 2,
              }}
            >
              <LocalPhoneOutlinedIcon />
              <Typography id="modal-modal-description" sx={{ ml: 2 }}>
                0344 075 7001
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 2,
              }}
            >
              <MailOutlinedIcon />
              <Typography id="modal-modal-description" sx={{ ml: 2 }}>
                <a href="mailto:hannandev01@gmail.com" target="_blank">
                  hannandev01@gmail.com
                </a>
              </Typography>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Thanks for your patience!
            </Typography>
          </Box>
        )}
      </Modal>
      <div
        className="contacts"
        id="contacts"
        style={{ backgroundColor: theme.secondary }}
      >
        <div className="contacts--container">
          <h1 style={{ color: theme.primary, marginLeft: 10 }}>Contact</h1>

          <div className="contacts-body">
            {/* Contact Form */}
            <div style={{ marginRight: 10 }} className="contacts-form">
              <form
                ref={form}
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <label htmlFor={"company"} className={classes.label}>
                  Company Name
                </label>
                <input
                  placeholder={"Microsoft"}
                  value={contactInfo.company}
                  onChange={handleChange}
                  name={`company`}
                  className={`form-input ${classes.input}`}
                />
                {submitClicked && !contactInfo.company && (
                  <p style={{ color: "red" }}>
                    Please enter valid company name
                  </p>
                )}
                <label htmlFor={"YourName"} className={classes.label}>
                  Your Name
                </label>
                <input
                  placeholder={"John Doe"}
                  value={contactInfo.YourName}
                  onChange={handleChange}
                  name={`YourName`}
                  className={`form-input ${classes.input}`}
                />
                {submitClicked && !contactInfo.YourName && (
                  <p style={{ color: "red" }}>
                    Please enter valid company name
                  </p>
                )}
                <label htmlFor={"email"} className={classes.label}>
                  Email
                </label>
                <input
                  placeholder={"JohnDoe@example.com"}
                  value={contactInfo.email}
                  onChange={handleChange}
                  name={`email`}
                  className={`form-input ${classes.input}`}
                />
                {submitClicked && !validateEmail(contactInfo.email) && (
                  <p style={{ color: "red" }}>
                    Please enter valid company name
                  </p>
                )}
                <label htmlFor={"phone"} className={classes.label}>
                  Phone no
                </label>
                <input
                  placeholder={"03xx-xxxxxxx"}
                  value={contactInfo.phone}
                  onChange={handleChange}
                  name={`phone`}
                  className={`form-input ${classes.input}`}
                />
                {submitClicked && !validatePhoneNumber(contactInfo.phone) && (
                  <p style={{ color: "red" }}>
                    Please enter valid company name
                  </p>
                )}
                <label htmlFor={"message"} className={classes.label}>
                  Message
                </label>
                <textarea
                  placeholder="Type your message...."
                  value={contactInfo.message}
                  onChange={handleChange}
                  name="message"
                  className={`form-message ${classes.message} `}
                />
                <div className="submit-btn">
                  <button
                    disabled={submitDisabled}
                    onClick={handleSubmit}
                    className={classes.submitBtn}
                    style={{ backgroundColor: submitDisabled ? "#ccc" : "" }}
                  >
                    <p>{!success ? "Send" : "Sent"}</p>
                    <div className="submit-icon">
                      <AiOutlineSend
                        className="send-icon"
                        style={{
                          animation: !success
                            ? "initial"
                            : "fly 0.8s linear both",
                          position: success ? "absolute" : "initial",
                        }}
                      />
                      <AiOutlineCheckCircle
                        className="success-icon"
                        style={{
                          display: !success ? "none" : "inline-flex",
                          opacity: !success ? "0" : "1",
                        }}
                      />
                    </div>
                  </button>
                </div>
              </form>
            </div>
            <div style={{ padding: 10 }} className="contacts-form">
              <form
                ref={form}
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div
                  style={{
                    backgroundColor: isDark
                      ? "rgb(29, 255, 26,0.2)"
                      : "rgb(0, 0, 0,0.8)",
                    borderRadius: 20,
                    color: isDark ? "#fff" : "#fff",
                    padding: 10,
                  }}
                >
                  <h3>Pick Date of Interview</h3>
                  <DayPicker
                    mode="single"
                    selected={selectedDate}
                    onSelect={setSelectedDate}
                    disabledDays={{ before: currentDate }}
                    footer={
                      selectedDate
                        ? `Selected: ${convertDateToString(selectedDate)} ${
                            contactInfo.timeSlot
                          }`
                        : "Pick a day."
                    }
                  />
                </div>
                <div>
                  <h3
                    style={{
                      color: isDark ? "#fff" : "#13B30D",
                      marginTop: 15,
                    }}
                  >
                    Time Slot
                  </h3>
                  <div style={{ display: "flex", gap: 5, marginTop: 5 }}>
                    <Chip
                      label="9am - 10am"
                      variant={
                        contactInfo.timeSlot == "9am - 10am" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          timeSlot: "9am - 10am",
                        });
                      }}
                    />
                    <Chip
                      label="8pm - 9pm"
                      variant={
                        contactInfo.timeSlot == "8pm - 9pm" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          timeSlot: "8pm - 9pm",
                        });
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", gap: 5, marginTop: 5 }}>
                    <Chip
                      label="9pm - 10pm"
                      variant={
                        contactInfo.timeSlot == "9pm - 10pm" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          timeSlot: "9pm - 10pm",
                        });
                      }}
                    />
                    <Chip
                      label="10pm - 11pm"
                      variant={
                        contactInfo.timeSlot == "10pm - 11pm" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          timeSlot: "10pm - 11pm",
                        });
                      }}
                    />
                  </div>
                  <h3
                    style={{
                      color: isDark ? "#fff" : "#13B30D",
                      marginTop: 15,
                    }}
                  >
                    Interview Type
                  </h3>
                  <div style={{ display: "flex", gap: 5, marginTop: 5 }}>
                    <Chip
                      label="Online"
                      variant={
                        contactInfo.interviewType == "online" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          interviewType: "online",
                        });
                      }}
                    />
                    <Chip
                      label="Onsite"
                      variant={
                        contactInfo.interviewType == "onsite" ? "" : "outlined"
                      }
                      onClick={() => {
                        setContactInfo({
                          ...contactInfo,
                          interviewType: "onsite",
                        });
                      }}
                    />
                  </div>
                  {contactInfo.interviewType == "onsite" ? (
                    <>
                      <label htmlFor={"Location"} className={classes.label}>
                        Pin Location (Google map)
                      </label>
                      <input
                        placeholder={"Pin Location"}
                        value={contactInfo.Location}
                        onChange={handleChange}
                        name={`Location`}
                        className={`form-input ${classes.input}`}
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor={"meetingLink"} className={classes.label}>
                        Meeting Link
                      </label>
                      <input
                        placeholder="Meeting link"
                        value={contactInfo.meetingLink}
                        onChange={handleChange}
                        name={`meetingLink`}
                        className={`form-input ${classes.input}`}
                      />
                    </>
                  )}
                </div>
              </form>
            </div>

            <div className="contacts-details">
              <a
                href={`mailto:${contactsData.email}`}
                className="personal-details"
              >
                <div className={classes.detailsIcon}>
                  <FiAtSign />
                </div>
                <p style={{ color: theme.tertiary }}>{contactsData.email}</p>
              </a>
              <a
                href={`tel:${contactsData.phone}`}
                className="personal-details"
              >
                <div className={classes.detailsIcon}>
                  <FiPhone />
                </div>
                <p style={{ color: theme.tertiary }}>{contactsData.phone}</p>
              </a>
              <div className="personal-details">
                <div className={classes.detailsIcon}>
                  <HiOutlineLocationMarker />
                </div>
                <p style={{ color: theme.tertiary }}>{contactsData.address}</p>
              </div>

              <div className="socialmedia-icons">
                {contactsData.twitter && (
                  <a
                    href={contactsData.twitter}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaTwitter aria-label="Twitter" />
                  </a>
                )}
                {contactsData.github && (
                  <a
                    href={contactsData.github}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaGithub aria-label="GitHub" />
                  </a>
                )}
                {contactsData.linkedIn && (
                  <a
                    href={contactsData.linkedIn}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaLinkedinIn aria-label="LinkedIn" />
                  </a>
                )}

                {contactsData.youtube && (
                  <a
                    href={contactsData.youtube}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaYoutube aria-label="YouTube" />
                  </a>
                )}

                {contactsData.facebook && (
                  <a
                    href={contactsData.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaFacebook aria-label="facebook" />
                  </a>
                )}
                {contactsData.medium && (
                  <a
                    href={contactsData.medium}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialIcon}
                  >
                    <FaWhatsapp aria-label="Whatsapp" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUI;
